var addValidate = false;
var i18n = require('i18n');
var util = require('../../app/util');
var doAjax = require('./ajax');
var topicId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
var replyToLayer = require('../../app/editorLayer.html');
var editorId = 'reply-to';

$('body').append(replyToLayer({
  id: editorId,
  title: i18n('reply.topic'),
  showReply: true,
  tinymce: true,
  markdown: true,
  markcheck: true,
  lines: 15
}));
$('.reply-to-layer').modal({
  closable: false,
  refresh: false,
  onHide: function () {
    window.scrollTo(0, window.enhancerScrollTop);
  },
  onHidden: function () {
    $(this).find('.markdown-editor').val('');
    tinyMCE.get('tinymce-' + editorId).setContent('');
  }
});

module.exports = function (success) {
  if (addValidate) {
    return;
  }
  addValidate = true;

  $('.reply-to-layer .submit').click( function () {
    var layer = $('.reply-to-layer');
    var mode = $(this).data('mode');
    var editorType;
    if (mode === 'edit') {
      editorType = $(this).data('editor');
    } else {
      editorType = layer.find('input[name=editorType]').prop('checked') ? 'markdown' : 'html';
    }
    
    var content;
    if (editorType === 'markdown') {
      content = layer.find('.markdown-editor').val();
      content = content.replace(new RegExp('</script>', 'gm'), '&lt;/script>');
    } else {
      content = tinyMCE.get('tinymce-' + editorId).getContent({ format: "raw"});
    }

    if (content.length < pageConfig.topicContent.min || content.length > pageConfig.topicContent.max) {
      util.show(i18n('tip.content.length', {min: pageConfig.topicTitle.min, max: pageConfig.topicTitle.max}))
      return
    }
      
    var data = {
      tid: topicId,
      cid: $(this).data('cid'),
      content: content.replace(/data-mce-src="[^"]+"/g, ''),
      editorType: editorType
    }
    
    util.uploadImage(data.content, editorType, function (content) {
      data.content = content || data.content;
      doAjax(mode + 'Comment', data, function (res) {

        layer.find('.close').click();
        res.data = res.data || {}
        res.data.editorType = editorType;
        
        success(res.data, data, mode);
      });
    });
  });


  var createEditor = require('../../app/editor');
  createEditor(editorId);
}



// WEBPACK FOOTER //
// ./src/pages/topic/replyToLayer.js